import styled from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';

export const StyledVisitHeader = styled.header`
   display: flex;
   justify-content: space-between;
   align-items: center;
   gap: 8px;
   width: 100%;
`;

StyledVisitHeader.displayName = 'StyledVisitHeader';

export const StyledVisitHeaderPatientContent = styled.div`
   display: flex;
   flex-direction: column;
   gap: 4px;
   overflow: hidden;
   flex: 1;
`;

StyledVisitHeaderPatientContent.displayName = 'StyledVisitHeaderPatientContent';

export const StyledVisitHeaderDetails = styled.div`
   ${basicBodyTextStyle};
   display: flex;
   gap: 16px;
`;

StyledVisitHeaderDetails.displayName = 'StyledVisitHeaderDetails';
